import "./footer.scss";
import stackedOvals from "../../assets/icons/loops.svg";

function Footer() {
  return (
    <div className="footer">
      <div className="footer-left">
        <img className="footer-left__img" src={stackedOvals} alt="3 stacked ovals" />
      </div>
      <div className="footer-right">
        <h1 className="footer-right__title">
          Wear <span className="footer-right__title-bottom">Everyday</span>
        </h1>
      </div>
    </div>
  );
}

export default Footer;
